module.exports = __webpack_public_path__ + "assets/img/thumb-logitech-landingpage-and-website.b486eae6.webp";